import { ElementId } from '~/features/shared/ad/types'

export const headerAd = 'topAdBigBanner' satisfies ElementId

export const leftNavAd = 'adLeftNav' satisfies ElementId
/** ページ下部(フッター上部)広告 */
export const pageBottomPcAds = [
  'adContentBottomLeft',
  'adContentBottomRight',
] satisfies [ElementId, ElementId]

export const pageBottomSpAds = 'gAdftrRectangle' satisfies ElementId

/** リスト内広告 */
export const inListPcAds = [
  {
    afterRows: 5, // 5行目の後に広告を表示
    ad: ['gAdlstMobileBanner00', 'gAdlstMobileBanner01'],
  },
  {
    afterRows: 10, // 10行目の後に広告を表示
    ad: ['gAdlstMobileBanner10', 'gAdlstMobileBanner11'],
  },
] satisfies { afterRows: number; ad: [ElementId, ElementId] }[]

export const inListSpAds = [
  {
    afterRows: 2, // 2行目の後に広告を表示
    ad: 'gAdlstMobileBanner0',
  },
  {
    afterRows: 10, // 10行目の後に広告を表示
    ad: 'gAdlstMobileBanner1',
  },
] satisfies { afterRows: number; ad: ElementId }[]
